<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-2">
        <base-input
          type="search"
          placeholder="Cari kode atau nama"
          :shadow="false"
          debounce
          v-model="filter.search"
          @native-input="loadProducts"
        />
      </div>
      <datatable
        :columns="[
          { id: 'code', name: 'Kode Barang' },
          { id: 'name', name: 'Nama Barang' },
          { id: 'category', name: 'Kelompok Produk' },
        ]"
        :total="products.meta.page.total"
        :perPage="products.meta.page.perPage"
        :currentPage="products.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="product in products.data"
            :key="product.id"
            :class="[classes.tr, 'cursor-pointer bg-white hover:bg-green-100']"
            @click="onClickProduct(product)"
          >
            <td :class="classes.td">
              <p class="font-bold text-gray-900">
                {{ product.attributes.code }}
              </p>
            </td>
            <td :class="classes.td">{{ product.attributes.name }}</td>
            <td :class="classes.td">
              {{ product.attributes.product_category_name ?? '-' }}
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <view-product-modal
      :visible="detailProduct.visible"
      :product-id="detailProduct.productId"
      :product-code="detailProduct.productCode"
      :detail-columns="['volume']"
      :col="4"
      @close="detailProduct.visible = false"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import ViewProductModal from '@/components/product/view-product-modal.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: { ViewProductModal },
  data() {
    return {
      detailProduct: {
        productId: null,
        productCode: null,
        visible: false,
      },
      filter: {
        search: null,
      },
      loading: false,
      products: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadProducts(params) {
      this.loading = true;

      const [res, err] = await this.request('/api/v1/products', {
        params: {
          'page[size]': 5,
          'fields[products]': 'code,name,product_category_name',
          'filter[search]': this.filter.search,
          'filter[is_product]': true,
          sort: '-createdAt',
          ...params,
        },
      });

      if (!err) {
        this.products = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadProducts({
        'page[number]': page,
      });
    },
    onClickProduct(product) {
      this.detailProduct.productId = product.id;
      this.detailProduct.productCode = product.attributes.code;
      this.detailProduct.visible = true;
    },
  },
  created() {
    this.loadProducts();
  },
};
</script>
